import request from '@/utils/request'

export function login(username, password, code) {
  return request({
    url: '/home/login',
    method: 'post',
    data: {
      userName: username,
      userPwd: password,
      code: code
    }
  })
}

export function getInfo() {
  return request({
    url: '/user/menu',
    method: 'post',
    data: {
      id: 1
    }
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/user/list',
    method: 'post',
    data: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/user/add',
    method: 'post',
    data: data
  })
}

export function updateAdmin(data) {
  return request({
    url: '/user/edit/',
    method: 'post',
    data: data
  })
}

export function updateStatus(data) {
  return request({
    url: '/user/edit/',
    method: 'post',
    data: data
  })
}

export function getAdmin(data) {
  return request({
    url: '/user/get',
    method: 'post',
    data: data
  })
}


export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/user/allocation',
    method: 'post',
    data: data
  })
}

export function allocStation(data) {
  return request({
    url: '/user/allocStation',
    method: 'post',
    data: data
  })
}

export function fetchUserIdStationList(data) {
  return request({
    url: '/user/station/get',
    method: 'post',
    data: data
  })
}

export function privacyList(data) {
  return request({
    url: '/user/privacy/',
    method: 'post',
    data: data
  })
}





// WEBPACK FOOTER //
// ./src/api/login.js